export default __webpack_public_path__ + "static/media/workshop2.1d47f6cb.JPG";